import superagent from 'superagent'
import { logout as userLogout } from './auth-actions'

export const userGet = user => ({
  type: 'USER_GET',
  payload: user
})

export const userFetchRequest = () => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/user/get`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        // Handle auth errors explicitly
        if (res && res.status === 401) {
          // Optional: logout user or refresh token
          dispatch(userLogout())

          // DO NOT reject with error → prevents Sentry error log
          return resolve(null)
        }

        // Real network or server errors only
        if (err) {
          reject(err)
          return
        }

        dispatch(userGet(res.body))
        resolve(res.body)
      })
  })
}
//       .get(`${__API_URI__}/user/get`)
//       .set('Authorization', `Bearer ${token}`)
//       .set('Content-Type', 'application/json')
//       .set('Platform', 'Web')
//       .set('Version', `${__version__}`)
//       .end((err, res) => {
//         if (err) {
//           reject(res.status)
//         }
//         dispatch(userGet(res.body))
//         resolve(res.body)
//         // return res.body
//       })
//   })
// }

export const userUpdateRequest = userObj => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .put(`${__API_URI__}/user/update`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(userObj))
      .end((err, res) => {
        if (err) {
          resolve(err)
        }
        dispatch(userFetchRequest()).then(() => {
          resolve(res.body)
        })
      })
  })
}

const userSearchRequest = (value, token, page, pageSize, collection = []) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/user/search?search=${value}&page=${page}&pageSize=${pageSize}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          if (res.body.length < pageSize) {
            resolve(collection.concat(res.body))
            return
          }
          resolve(userSearchRequest(value, token, page + 1, pageSize, collection.concat(res.body)))
        }
      })
  })
}

export const userSearch = value => (dispatch, getState, token) => {
  return userSearchRequest(value, token, 0, 100)
}

export const cancelUserSubscription = (userPlanId, callback) => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .delete(`${__API_URI__}/UserSubscription/Cancel?userPlanId=${userPlanId}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          callback({ res: err, statusCode: 8888 })
          reject(err)
        } else {
          dispatch(userFetchRequest()).then(() => {
            callback({ res: res.body, statusCode: 1000 })
            resolve(res.body)
          })
        }
      })
  })
}
